(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-request"] && !Shopify.designMode) return;
  try {
    
  document.getElementById("bulkForm").addEventListener("submit", function(e) {
    e.preventDefault();

    const data = Object.fromEntries(new FormData(this));
    fetch("https://script.google.com/macros/s/AKfycbxSHaeon9iphiSeJ9sA63VqzJKIMrcg1s-qCqclzl9Ay6hN82dfQSRw0wJONitXCvWU/exec", {
      method: "POST",
      headers: {
        "Content-Type": "text/plain;charset=utf-8"
      },
      body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(() => {
      document.getElementById("formMsg").innerText = "Submitted successfully!";
      this.reset();
    })
    .catch(err => {
      document.getElementById("formMsg").innerText = "Error submitting form";
      console.error(err);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
